<template>
  <div class="dataset">

    <transition
      enter-active-class="anim-turnup"
      leave-active-class="anim-turnup anim-reverse"
      mode="out-in"
    >

      <div
        class="table-wrapper is-flex-expand"
        key="table"
        v-if="!loading"
      >
        <table
          class="table is-hoverable"
          :class="[tableCls]"
        >

          <!-- header -->
          <dataset-head
            :columns="columns"
            :sort="paginate.sort"
            :set-sort="setSort"
            :checkedrows.sync="checkedrows"
            :rows="data"
          />

          <tbody>

            <dataset-row
              v-for="(d, d_offset) in data"
              :key="d_offset"
              :columns="columns"
              :row="d"
            >
              <dataset-td
                v-for="column in columns"
                :key="column.key"
                :column="column"
                :row="d"
                :store="store"
                :meta="meta"
                :update-meta="updateMeta"
                :force-fetch="forceFetch"
                :checkedrows.sync="checkedrows"
                @edit="edit"
                @editButton="editButton"
                @delete="deleteRow"
                @showCombined="showCombined"
              />
            </dataset-row>

            <slot
              name="bottomRow"
              :columns="columns"
              :data="data"
            />

          </tbody>
        </table>
      </div>

      <dataset-loading
        key="loading"
        v-if="loading"
        :colspan="columns.length"
      >
        <slot name="loading" />
      </dataset-loading>
    </transition>

  </div>
</template>

<script>
import { initialize, getColumnInOrder } from './dataset-config'
import { getSourceAction } from './dataset-source'
import { debounce } from 'lodash'
import Vue from 'vue'
import store from '@/store'

export default {
  name: 'Dataset',
  components: {
    DatasetHead: require('./dataset-head').default,
    DatasetRow: require('./dataset-row').default,
    DatasetTd: require('./dataset-td').default,
    DatasetLoading: require('./dataset-loading').default,
  },
  props: {
    config: { type: Object, default: () => ({}) },
    // allow bind store into this. if bind store to this
    // dataset will pass it into every nodes
    store: { type: Object, default: () => null },
    // allow addon more data into parser action
    // this prop can use in case we want merge request context
    meta: { type: Object, default: () => null },
    // add classes into table element
    tableCls: { type: String, default: () => null },

    checkedrows: {type: Array, default: () => []},

    fulldata: {type: Array, default: () => []},

    storeVisibilityCommit: {type: String, default: () => ''}
  },
  data() {
    // create config & content for setup dataset
    return {
      ...initialize(this.config),
      loading: true,
      loadingMore: false,
      search: null
    }
  },
  computed: {
    // collect list column keys visible follow order
    columns() {
      return this.columnsInOrder.filter(col => col.visible)
    },
    columnsInOrder() {
      return getColumnInOrder(this.$data)
    },
    // detech when we out of data to fetch
    gotAllData() {
      return this.data && this.data.length === this.total
    },
  },
  async mounted() {
    this.$emit('ready')
    // console.log('mounted store', store.getters['filter/preferences'])
    // console.log('mounted config', this.config)
    const self = this
    this.loading = true
    setTimeout(() => self.fetch(), 300)

    // listen when visibility change
    // force reload with curent page
    this.$watch('visibility', list => {
      console.log('visibility change', list)
      if(this.storeVisibilityCommit){
        //store.commit(this.storeVisibilityCommit, list)
      }
      //console.log('store', store.getters['filter/preferences'])
      this.loading = true
      this.forceFetch()
    })
    this.$watch(
      'paginate.sort',
      list => {
        this.loading = true
        this.forceFetch()
      },
      { deep: true },
    )

    this.$watch(
      'meta',
      list => {
        this.loading = true
        this.forceFetch()
      },
      { deep: true },
    )

    this.$watch(
      'fulldata',
        list => {
        // this.loading = true
        self.forceFetch()
      },
      { deep: true },
    )
  },
  methods: {
    // hit source and get data
    async fetch() {
      // stop fetch if total == total length of data
      if (this.gotAllData) return false

      const action = getSourceAction(this.source_type)
      
      try {
        if(this.source_type === 'ARRAY'){
          const result = await action(this.fulldata, this.$data)
          const resultTranspiled = this.transpileData(result.data)

          this.total = result.total
          //Array.isArray(this.data) ? this.data = resultTranspiled : []
          Array.isArray(this.data)
            ? (this.data = this.data.concat(resultTranspiled))
            : (this.data = resultTranspiled)
          //notify latest data fetched
          this.$emit('fetched', resultTranspiled)
        }
        else{
          const result = await action(this.source, this.$data, this.meta, false)
          const resultTranspiled = this.transpileData(result.data)
          this.total = result.total
          Array.isArray(this.data)
            ? (this.data = this.data.concat(resultTranspiled))
            : (this.data = resultTranspiled)
          //notify latest data fetched
          this.$emit('fetched', resultTranspiled)
        }
        this.loading = false
      } catch (e) {
        this.loading = false
        console.error(e)
        return []
      }
    },

    // resync data with current status
    // in case dataset not stay in page 1 we need calcualte how many row shown
    // then request data wit hmatch total row to redraw table
    async forceFetch() {
        try {
          const action = getSourceAction(this.source_type)
          // third param is for resync
          
          if(this.source_type === 'ARRAY'){
            const result = await action(this.fulldata, this.$data)
            const resultTranspiled = this.transpileData(result.data)

            this.total = result.total
            Vue.set(this, 'data', resultTranspiled)
            this.$emit('fetched', resultTranspiled)
          }else{
            const result = await action(this.source, this.$data, this.meta, true)
            const resultTranspiled = this.transpileData(result.data)

            this.total = result.total
            Vue.set(this, 'data', resultTranspiled)
            this.$emit('fetched', resultTranspiled)
          }
          this.loading = false
        } catch (e) {
          this.loading = false
          console.error(e)
          // no remove list, keep current one as latest data can view
          return false
        }
     
    },

    // change total column can visible
    setVisible(value) {
      // if provide array then replace visibility
      if (Array.isArray(value)) return (this.visibility = value)
      // set single node
      const offset = this.visibility.indexOf(value)
      if (offset === -1)
        this.visibility = Array.from(new Set(this.visibility.concat(value)))
      else this.visibility.splice(offset, 1)
      this.$emit('setVisible', this.visibility)
    },

    // change order columns
    setOrder(list) {
      console.log(list)
      this.field_order = list
    },

    // switch sorting
    setSort(key) {
      const sort = this.paginate.sort
      // if switch same field sorted before, we change order
      if (sort.field === key) sort.order = sort.order === 'ASC' ? 'DESC' : 'ASC'
      else sort.order = 'ASC'
      this.paginate.sort.field = key
      return sort
    },

    // load more action
    // increase page value to 1
    // hit server
    async loadmore() {
      const self = this
      self.paginate.page += 1
      this.loadingMore = true
      await self.forceFetch()
      this.loadingMore = false
    },

    // clear meta data
    updateMeta(explains) {
      this.$emit('updateMeta', explains)
    },
    clearMeta() {
      this.updateMeta(null)
    },

    // transpile data before bind to web
    transpileData(data) {
      return data
    },

    edit(row){
      this.$emit('edit', row)
    },

    editButton(row){
      this.$emit('editButton', row)
    },

    deleteRow(row){
      this.$emit('deleteRow', row)
    },

    async showCombined(row){
      this.fulldata.forEach(item => {
        if(row.combinedIds.indexOf(item.id) !== -1){
          item.showCombined = true
        }
        else{
          item.showCombined = false
        }
      })
      await this.forceFetch()
    }

  },
}
</script>

<style lang="scss" scoped>
.dataset {
  position: relative;
  min-height: 210px;
  font-size: 0.9rem;

  .table-wrapper {
    min-height: 210px;
  }

  .table {
    background: none;
    width: 100%;

    &.is-vcentered td {
      vertical-align: middle;
    }
  }

  .loading_more {
    text-align: center;
  }
}

.table-wrapper {
  width: 100%;
}
</style>
